/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  app.Filters.TreeFilterView = app.Filters.CheckboxListView.extend({
    events: {
      'click .js-show-all-categories': 'showAllCategories',
      'click #filter-category-item-all a': 'showAllCategories',
      'click .filter-show, .filter-hide': 'filterToggle',
    },

    /** @inheritDoc */
    beforeRun: function (data) {
      var template = '#tree-filter-view';
      this.isCategory = data.object.name === 'category';
      this.template = app.helpers.TemplateHelper.getTemplate(template);
      this.object.count = _.sumBy(_.get(this.object, 'values'), 'total_count');
    },

    /**
     * @inheritDoc
     */
    run: function (data) {
      app.Filters.CheckboxListView.prototype.run.apply(this, arguments);
      if (this.filtersInOneRow) {
        this.moreButtonTemplate = app.helpers.TemplateHelper.getTemplate('#more-filters-template');
        this.$categoryTabs = $('.category-tabs');
        if (!this.$categoryTabs.hasClass('expanded')) {
          this.listenTo(this, 'children-rendered', this.wrapFiltersInOneRow);
          this.listenTo(Backbone, 'window.resize.debounced', this.wrapFiltersInOneRow);
        }
      }
    },

    /**
     * Показать товары всех категорий.
     * @param {Event} e Событие клика.
     */
    showAllCategories: function (e) {
      if (this.isCategory) {
        this.model.all = true;
        $(e.currentTarget).addClass('selected');
      }
    },

    /**
     * Сворачивает фильтры в одну строку, добавляет кнопку "ещё..".
     */
    wrapFiltersInOneRow: function () {
      this.$moreButton && this.$moreButton.remove();
      this.$filterTabs = this.$filterTabs || this.$categoryTabs.find('.js-category-filter');
      this.$moreButton = app.helpers.DomHelper.hideExcessElementsAndAddButton(
        this.$categoryTabs,
        this.$filterTabs,
        1,
        this.moreButtonTemplate,
        this.expandFilters.bind(this)
      );
    },

    /**
     * Разворачивает скрытые фильтры.
     */
    expandFilters: function () {
      this.$filterTabs.removeClass('not_display');
      this.$moreButton.remove();
      this.stopListening(Backbone, 'window.resize.debounced', this.wrapFiltersInOneRow);
      this.$categoryTabs.addClass('expanded');
    }
  });
})(jQuery);

}.call(window));